/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeleteStockupItem200ResponseAllOfData } from './DeleteStockupItem200ResponseAllOfData';
import {
    DeleteStockupItem200ResponseAllOfDataFromJSON,
    DeleteStockupItem200ResponseAllOfDataFromJSONTyped,
    DeleteStockupItem200ResponseAllOfDataToJSON,
} from './DeleteStockupItem200ResponseAllOfData';

/**
 * 
 * @export
 * @interface DeleteStockupItem200ResponseAllOf
 */
export interface DeleteStockupItem200ResponseAllOf {
    /**
     * 
     * @type {DeleteStockupItem200ResponseAllOfData}
     * @memberof DeleteStockupItem200ResponseAllOf
     */
    data: DeleteStockupItem200ResponseAllOfData;
}

/**
 * Check if a given object implements the DeleteStockupItem200ResponseAllOf interface.
 */
export function instanceOfDeleteStockupItem200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function DeleteStockupItem200ResponseAllOfFromJSON(json: any): DeleteStockupItem200ResponseAllOf {
    return DeleteStockupItem200ResponseAllOfFromJSONTyped(json, false);
}

export function DeleteStockupItem200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteStockupItem200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': DeleteStockupItem200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function DeleteStockupItem200ResponseAllOfToJSON(value?: DeleteStockupItem200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DeleteStockupItem200ResponseAllOfDataToJSON(value.data),
    };
}

